import { render } from "./ContattiPage.vue?vue&type=template&id=77de4310"
import script from "./ContattiPage.vue?vue&type=script&lang=js"
export * from "./ContattiPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__